var map = {
	"./blackjack.webp": "576b",
	"./blackjack1.webp": "e2ed",
	"./cases.webp": "6210",
	"./crash.webp": "e752",
	"./duels.webp": "0688",
	"./duels1.webp": "98f5",
	"./mines.webp": "1e31",
	"./placeholder.webp": "e133",
	"./roll.webp": "6c99",
	"./spin.webp": "2cf8",
	"./towers.webp": "2ba0",
	"./upgrader.webp": "abb4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6d6a";